import type { SVGProps } from "react";

const MeasureIcon = ({
  width = 30,
  height = 30,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M17.5 25.625V5.312c0-.91-.002-1.498-.06-1.932-.055-.407-.143-.534-.215-.605-.071-.072-.198-.16-.605-.215-.434-.058-1.022-.06-1.933-.06-.91 0-1.498.002-1.932.06-.407.055-.534.143-.605.215-.072.071-.16.198-.215.605-.058.434-.06 1.022-.06 1.933v20.312H17.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      d="M10 10.938A.937.937 0 0 0 9.062 10h-3.75a.937.937 0 0 0-.937.938v14.687H10V10.937ZM25 17.188a.938.938 0 0 0-.938-.938h-3.75a.937.937 0 0 0-.937.938v8.437H25v-8.438Z"
      opacity={0.7}
    />
    <path
      fill="#000"
      d="M2.188 25.625a.937.937 0 1 0 0 1.875h25a.938.938 0 0 0 0-1.875H2.186Z"
      opacity={0.5}
    />
  </svg>
);
export default MeasureIcon;
